// extracted by mini-css-extract-plugin
module.exports = {"alertButton":"alerts_alertButton__cTuWb"};